// extracted by mini-css-extract-plugin
export default {"root":"IconPaid_root__JLnCc"};